import React from 'react';
import { Input, Button, Icon } from 'antd';

export default class FilterTable {
  static propTypes = {};
  state = {
    searchText: '',
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Procurar`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Buscar
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Limpar
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      const auxDataIndex = dataIndex.split('.');

      let auxRecord = {};
      for (var i = 0; i < auxDataIndex.length; i++) {
        if (i === 0) {
          if (Array.isArray(record[auxDataIndex[i]])) {
            auxRecord = record[auxDataIndex[i]][0];
          } else {
            auxRecord = record[auxDataIndex[i]];
          }
        } else {
          if (auxRecord) {
            if (Array.isArray(record[auxDataIndex[i]])) {
              auxRecord = auxRecord[auxDataIndex[i]][0];
            } else {
              auxRecord = auxRecord[auxDataIndex[i]];
            }
          }
        }
      }

      if (auxRecord) {
        return auxRecord
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      } else {
        return false;
      }
    },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    //this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    //  this.setState({ searchText: '' });
  };
}



// WEBPACK FOOTER //
// ./src/features/common/FilterTable.js